import React, { useEffect } from "react";

// Store
import { pathTitles, useStore } from "../../Store/Store";
// Components
import { Loader, PageOverLay, SEO, TrainingInfo } from "..";

export const DayTraining = () => {
  const checkServices = useStore((state) => state.checkServices);
  const getLink = useStore((state) => state.getLink);
  const loading = useStore((state) => state.loading);
  const trainingDetails = useStore((state) => state.trainingDetails);
  const dayTrainingPrograms = useStore((state) => state.dayTrainingPrograms);

  useEffect(() => {
    checkServices(trainingDetails);
  }, []);
  const overlay = {
    where: "dayTraining",
    title: "Day Training",
    caption: "How does she do it?",
  };
  const info = {
    routes: {
      Home: "/",
      Training: getLink(pathTitles.TRAINING),
      "Day Training": getLink(pathTitles.DAYTRAINING),
    },
    body: trainingDetails.DAYTRAINING.body,
    programs: dayTrainingPrograms,
  };
  return (
    <>
      <SEO
        title="Day Training for Dogs"
        description="Drop your dog off, we train, you pick up. Day Training at Todo's Translator delivers structured sessions with a professional trainer while your dog sleeps at home every night. Serving Indianapolis and surrounding areas."
        path="/training/day-training"
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          <PageOverLay overlay={overlay} />
          <TrainingInfo info={info} />
        </>
      )}
    </>
  );
};
